// ########################### Prognosis Qualitative Value ###########################
export const PrognosisValue_00 = 'prognosis-00';
export const PrognosisValue_10 = 'prognosis-10';
export const PrognosisValue_20 = 'prognosis-20';
export const PrognosisValue_30 = 'prognosis-30';
export const PrognosisValues = [PrognosisValue_00, PrognosisValue_10, PrognosisValue_20, PrognosisValue_30];
// ########################### Prognosis Rate Type ###########################
export const PrognosisRateType_Survival = 'survival';
export const PrognosisRateType_Mortality = 'mortality';
export const PrognosisRateType_Qualitative = 'qualitative';
export const PrognosisRateTypes = [PrognosisRateType_Survival, PrognosisRateType_Mortality, PrognosisRateType_Qualitative];
//# sourceMappingURL=types.js.map